import api from './axios';
import {
    SessionLog,
    CreateSessionLogRequest,
    UpdateSessionLogRequest
} from '../types/sessionLog';

export async function getSessionLogs(
    filters?: { teacher?: string; course?: string }
): Promise<SessionLog[]> {
    const params = filters || {};
    const res = await api.get<SessionLog[]>('/session-logs', { params });
    return res.data;
}

export async function getSessionLog(id: string): Promise<SessionLog> {
    const res = await api.get<SessionLog>(`/session-logs/${id}`);
    return res.data;
}

export async function createSessionLog(
    data: CreateSessionLogRequest
): Promise<SessionLog> {
    const res = await api.post<SessionLog>('/session-logs', data);
    return res.data;
}

export async function updateSessionLog(
    id: string,
    data: UpdateSessionLogRequest
): Promise<SessionLog> {
    const res = await api.patch<SessionLog>(`/session-logs/${id}`, data);
    return res.data;
}

export async function deleteSessionLog(id: string): Promise<void> {
    await api.delete(`/session-logs/${id}`);
}
